export const header_links = [
  {
    link: '/#project-section',
    label: 'Projects',
  },
  {
    link: '/#about-section',
    label: 'About',
  },
  {
    link: '/blog',
    label: 'Blog',
  },
];
